import React from 'react';
import PropTypes from 'prop-types';
import AppProviders from 'main/contexts/Provider';

export const ContextProviderComposer = ({ children }) => {
  return <AppProviders>{children}</AppProviders>;
};

ContextProviderComposer.propTypes = {
  children: PropTypes.node.isRequired,
};
